if (!customElements.get('pc-img-slider')) {
  class PcImgSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pc-img-slider__track');
      if (!this.track) return;

      this.dots = this.querySelectorAll('.pc-img-slider__dot');

      this.querySelector('.pc-img-slider__btn--prev')?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.slide(-1);
      });
      this.querySelector('.pc-img-slider__btn--next')?.addEventListener('click', (e) => {
        e.stopPropagation();
        this.slide(1);
      });

      this.track.addEventListener('scroll', () => this.updateState(), { passive: true });
      this.initNavigate();

      this.updateState();
      this.updateVisibility();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateState();
        this.updateVisibility();
      });
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    initNavigate() {
      const url = this.dataset.productUrl;
      if (!url) return;
      let startX = 0;
      let didScroll = false;
      this.track.addEventListener('pointerdown', (e) => {
        startX = e.clientX;
        didScroll = false;
      });
      this.track.addEventListener('pointermove', (e) => {
        if (Math.abs(e.clientX - startX) > 6) didScroll = true;
      });
      this.track.addEventListener('click', () => {
        if (!didScroll) window.location = url;
      });
    }

    slide(direction) {
      const item = this.track.querySelector('.pc-img-slider__item');
      if (!item) return;
      this.track.scrollBy({ left: direction * item.offsetWidth, behavior: 'smooth' });
    }

    updateState() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft >= scrollWidth - clientWidth - 1;

      const prevBtn = this.querySelector('.pc-img-slider__btn--prev');
      const nextBtn = this.querySelector('.pc-img-slider__btn--next');
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;

      if (this.dots.length > 0) {
        const itemWidth = this.track.querySelector('.pc-img-slider__item')?.offsetWidth || clientWidth;
        const index = Math.round(scrollLeft / itemWidth);
        this.dots.forEach((dot, i) => dot.classList.toggle('pc-img-slider__dot--active', i === index));
      }
    }

    updateVisibility() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 1;
      this.querySelectorAll('.pc-img-slider__btn').forEach((btn) => {
        btn.style.display = scrollable ? '' : 'none';
      });
      const dotsEl = this.querySelector('.pc-img-slider__dots');
      if (dotsEl) dotsEl.style.display = scrollable ? '' : 'none';
    }
  }

  customElements.define('pc-img-slider', PcImgSlider);
}
